/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deploymentBackfill} from '../api'

export const useMutationDeploymentBackfill = createReactQueryMutationHook('deploymentBackfill', deploymentBackfill)
